import React from 'react';

const t = (text, params) => I18n.t(text, { ...params });

export default t;
